/**
 * entryOptions.js
 * ---------------
 * Canonical style/size/level vocabularies for dance entries — the single
 * source of truth shared between the teacher entry form (EntryLibrary.js)
 * and the admin entry screening table (EventRegistrationSection.js), so the
 * two never drift apart (admin filters silently missing styles that the
 * teacher form actually offers, etc).
 */

export const STYLE_OPTIONS = ['Ballet', 'Contemporary', 'Cultural-Set Choreography', 'Cultural-Creative Choreography', 'Fusion', 'Hip Hop', 'Jazz', 'K-Pop', 'Lyrical', 'Modern', 'Musical Theatre-Lip Sync', 'Musical Theatre-Live Vocals', 'Open', 'Tap'];
export const SIZE_OPTIONS = ['Solo', 'Grad Solo', 'Duet', 'Trio', 'Small Group', 'Medium Group', 'Large Group'];
export const LEVEL_OPTIONS = ['Novice', 'Intermediate 1', 'Intermediate 2', 'Advanced 1', 'Advanced 2'];

// Include the special-category sentinel values so those entries stay
// reachable via filters: Freestyle entries save level = 'Freestyle', and
// Creative Collaboration entries save style = 'Creative Collaboration'.
export const FILTER_LEVELS = [...LEVEL_OPTIONS, 'Freestyle'];
export const FILTER_STYLES = [...STYLE_OPTIONS, 'Creative Collaboration'];

export const TYPE_OPTIONS = ['Standard', 'Freestyle', 'Creative Collaboration'];
export const FREESTYLE_STYLES = ['Contemporary', 'Hip Hop'];
export const START_POSITION_OPTIONS = ['On', 'Off', 'Not Sure'];

// Dancer-count ranges backing each Size option — see RulesPanel.js, where
// these same group sizes are used to set judge time limits.
export const SIZE_DANCER_RANGES = {
  Solo: [1, 1],
  'Grad Solo': [1, 1],
  Duet: [2, 2],
  Trio: [3, 3],
  'Small Group': [4, 9],
  'Medium Group': [10, 15],
  'Large Group': [16, Infinity],
};

// A participant only shows up in the standard entry's picker(s) for the
// role(s) they actually registered for — someone who registered as 'Dancer'
// shouldn't be selectable as a choreographer, and vice versa. 'Dancer and
// Choreographer' registrants are eligible for both. Freestyle entries pick
// from the full roster instead, since selecting someone there assigns them
// to both roles regardless of what they registered as.
export const DANCER_ROLES = ['Dancer', 'Dancer and Choreographer'];
export const CHOREOGRAPHER_ROLES = ['Choreographer', 'Dancer and Choreographer'];
